namespace Areas.Dialogs.CreateCollaborationAreaFolder {
    "use strict";

    export class CreateCollaborationAreaFolderDialog extends Areas.BaseDialog {
        formName: string;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateCollaborationAreaFolder", closeHandler, parameters, () => {
                this.formName = `${this.dialogName}Form`;
                const form = Areas.getForm(this.formName);
                form.option("formData", parameters.data);

                $("#ParentFolderName").html(`Parent folder: ${parameters.parentFolderName}`);
            });
        }

        protected ok = (e: any) => {
            const form = Areas.getForm(this.formName);
            const result: any = form.validate();

            if (result.isValid) {
                const newData: any = form.option("formData");

                sendRequest("/Dialog/CreateCollaborationAreaFolder/Post", JSON.stringify(newData), "POST")
                    .done(() => this.close(DialogResult.Ok,null));
            }
        }
    }

}